import React, { useEffect, useState,useRef } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { Box, VStack, Button, SimpleGrid, Stack, Text, Card, CardBody,Flex, Image,useDisclosure,AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay } from "@chakra-ui/react";
import { FaEdit, FaRupeeSign, FaTrash } from "react-icons/fa";
import toast from 'react-hot-toast';
import Cookie from 'js-cookie';
import FoodUpdateModal from './foodUpdateModal';

const FoodData = () => {
  const {isOpen,onOpen,onClose} = useDisclosure();
  const token=Cookie.get('token')
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [typeFilter, setTypeFilter] = useState('All');
  const [nameFilter, setNameFilter] = useState('All');
  const [uniqueNames, setUniqueNames] = useState([]);
  const [isOpen1,setIsOpen]=useState(false)
  const [food, setFood] = useState({});
  const [id, setId] = useState('');
const [deleteItemId, setDeleteItemId] = useState(null);
  const cancelRef = useRef();

  const customerId = localStorage.getItem('customerId');
  console.log(customerId);

  const fetchData = async () => {
    const response = await axios.get(`https://api.hotel.tdrsoftware.in/api/getFooddata/${customerId}`);
    const rooms = response.data;
    const updatedRooms = await Promise.all(
      rooms.map(async (room) => {
        if (room.image) {
          // Check if the image is already cached
    
          
            try {
              const imageResponse = await axios.get(`https://api.hotel.tdrsoftware.in/get-image/${room.image}`, {
                responseType: 'blob', // Assuming the image is returned as a blob
              });
    
              // Create a blob URL for the image
              //cachedUrl = URL.createObjectURL(imageResponse.data);
              
              // Cache the URL for future use
              room.imageUrl=URL.createObjectURL(imageResponse.data)
             
            } catch (error) {
              console.error(`Error fetching image for room: ${room.image}`, error);
              room.imageUrl = null; // Fallback in case of error
            }
          
    
           // Assign the cached or fetched URL
        } else {
          room.imageUrl = null; // Handle cases where image is missing
        }
        return room;
      })
    );
    
  
   // console.log(updatedRooms, 'updatedRooms');
    setData(updatedRooms);
    setFilteredData(updatedRooms);
    setUniqueNames(['All', ...new Set(updatedRooms.map(item => item.name))]);
  }

  const handleTypeFilterChange = (filter) => {
    setTypeFilter(filter);
    filterData(filter, nameFilter);
  }

  const handleNameFilterChange = (filter) => {
    setNameFilter(filter);
    filterData(typeFilter, filter);
  }
  const handleDelete = async () => {
    try {
      await axios.delete(`https://api.hotel.tdrsoftware.in/api/foodDelete/${customerId}/${deleteItemId}?customerId=${customerId}`,{
        headers: {
         Authorization: `Bearer ${token}`,
       }});
      toast.success('Food deleted successfully.');
      setIsOpen(false);

      fetchData();

    } catch (error) {
      toast.error(error.response.data.msg);
     // toast.error('Failed to delete room.');
    }
  };

const updateFood = async (id) => {
    try {
      const response = await axios.get(`https://api.hotel.tdrsoftware.in/api/getFooddataById/${customerId}/${id}`);
      setFood(response.data);
      setId(id);
      onOpen();
    } catch (error) {
      console.error('Error fetching room data for update:', error);
      toast.error('Failed to fetch room data.');
    }
  };
  const DeleteModal = (id) => {
    setDeleteItemId(id);
    setIsOpen(true);
  };

  const onClose1 = () => {
    setIsOpen(false);
    setDeleteItemId(null);
  };

  const filterData = (type, name) => {
    let filtered = data;
    if (type !== 'All') {
      filtered = filtered.filter(item => item.type === type);
    }
    if (name !== 'All') {
      filtered = filtered.filter(item => item.name === name);
    }
    setFilteredData(filtered);
  }

  useEffect(() => {
    fetchData();
  }, [customerId]);

  return (
    <Box>
      <Box display="flex" justifyContent="center" marginBottom="20px" gap="10px" mt={10}>
        <Button onClick={() => handleTypeFilterChange('All')} colorScheme={typeFilter === 'All' ? 'green' : 'gray'}>All</Button>
        <Button onClick={() => handleTypeFilterChange('Veg')} colorScheme={typeFilter === 'Veg' ? 'green' : 'gray'}>Veg</Button>
        <Button onClick={() => handleTypeFilterChange('Non-Veg')} colorScheme={typeFilter === 'Non-Veg' ? 'green' : 'gray'}>Non-Veg</Button>
      </Box>
      <Box display="flex" justifyContent="center" marginBottom="20px" gap="10px">
        {uniqueNames.map((name, index) => (
          <Button key={index} onClick={() => handleNameFilterChange(name)} colorScheme={nameFilter === name ? 'green' : 'gray'}>
            {name}
          </Button>
        ))}
      </Box>
      
      <SimpleGrid minChildWidth='280px' placeItems='center' height='fit-content' gap='20px' p={10}>
        {filteredData.map((item, index) => (
          <Card maxW='sm' key={index} boxShadow='dark-lg'>
            <CardBody>
              <Image
                src={item.imageUrl}
                alt={item.roomNo}
                borderRadius='lg'
                height='300px'
                width='full'
              />
              <Stack mt='6' spacing='3'>
                <Box display='flex' flexDirection='column' justifyContent='space-between' alignItems='left' p={2} >
                  <Box display='flex' gap={4} justifyContent='space-between'>
                    <Text size='md'><b>Name</b> : {item.name}</Text>
                    <Text size='md'><b>Category</b> : {item.category}</Text>
                  </Box>
                  <Box display='flex' mt={10} gap={4} justifyContent='space-between'>
                    <Text size='md'><b>Type</b> : {item.type}</Text>
                    <Text><b>Description</b> {item.description}</Text>
                  </Box>
                </Box>
                
                <Flex justifyContent="space-between">
                <Text color='blue.600' fontSize='2xl' display='flex' justifyContent='center' alignItems='center'>
                  <FaRupeeSign /> {item.rate}
                </Text>
                                  <Flex gap={2}>
                                    <Button variant="ghost" colorScheme="green" onClick={() => updateFood(item._id)}>
                                      <FaEdit />
                                    </Button>
                                    <Button variant="ghost" colorScheme="red" onClick={() => DeleteModal(item._id)}>
                                     <FaTrash />
                                    </Button>
                                  </Flex>
                                </Flex>
              </Stack>
            </CardBody>
          </Card>
        ))}
      </SimpleGrid>
      <FoodUpdateModal customerId={customerId} isOpen={isOpen} onOpen={onOpen} onClose={onClose} data={food} id={id} setSelectId={setId} />
      <AlertDialog isOpen={isOpen1} leastDestructiveRef={cancelRef} onClose={onClose1}>
      <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>

            <AlertDialogBody>Are you sure you want to delete this item?</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose1}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>


    </Box>
  )
}

export default FoodData;
